"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangePaymentDayPriceOutputWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var ordinal = require("ordinal-js");
var react_router_dom_1 = require("react-router-dom");
var moment = require("moment");
var commonFunctions_1 = require("../../commonFunctions");
var ChangePaymentDayPriceOutputWidget = /** @class */ (function (_super) {
    __extends(ChangePaymentDayPriceOutputWidget, _super);
    function ChangePaymentDayPriceOutputWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.paymentRequired = _this.props.interaction.factors.additionalPremium > 0;
        _this.refundRequired = _this.props.interaction.factors.returnPremium > 0;
        _this.renderQuestions = function () {
            return React.createElement(plugin_journey_1.QuestionList, __assign({}, _this.props, { questions: _this.props.question.questions }));
        };
        return _this;
    }
    ChangePaymentDayPriceOutputWidget.prototype.componentDidMount = function () {
        window.sessionStorage.removeItem("mtaChangePaymentDayAdditionalPremium");
        if (this.paymentRequired) {
            window.sessionStorage.setItem("mtaChangePaymentDayAdditionalPremium", this.props.interaction.factors.additionalPremium.toString());
        }
    };
    ChangePaymentDayPriceOutputWidget.prototype.render = function () {
        var nextSubscriptionEndDate = moment.utc(this.props.interaction.headerInfo.endDate);
        var nextSubscriptionEndDay = ordinal.toOrdinal(nextSubscriptionEndDate.date());
        var nextSubscriptionEndMonth = moment.utc(this.props.interaction.headerInfo.endDate).format("MMMM");
        return (React.createElement("div", { className: "widget plugin" },
            React.createElement("div", { className: "_panel py-md-4" },
                React.createElement("div", null,
                    React.createElement("div", { id: "price", className: "price text-center font-weight-bold font-family-display text-blue-2" },
                        this.paymentRequired && React.createElement(React.Fragment, null, (0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.factors.additionalPremium)),
                        this.refundRequired && React.createElement(React.Fragment, null,
                            (0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.factors.returnPremium),
                            " refund")),
                    React.createElement("div", { id: "next-subscription-end-date", "data-next-subscription-end-date": nextSubscriptionEndDate.format("DD-MM-YYYY"), className: "text-center font-weight-bold" },
                        this.paymentRequired && React.createElement(React.Fragment, null,
                            "To cover up to ",
                            nextSubscriptionEndDay,
                            " of ",
                            nextSubscriptionEndMonth),
                        this.refundRequired && React.createElement(React.Fragment, null,
                            "You will get refund to cover up to ",
                            nextSubscriptionEndDay,
                            " of ",
                            nextSubscriptionEndMonth),
                        !this.paymentRequired && !this.refundRequired && React.createElement(React.Fragment, null, "Great news! There is no extra cost for the change you made!")))),
            React.createElement("div", { className: "_panel py-md-4" },
                React.createElement("div", { className: "text-center mt-4 mb-5" },
                    React.createElement("div", { className: "dashboard-panel-title my-3" }, "Payment day"),
                    React.createElement("div", null,
                        "Every",
                        React.createElement("b", { className: "font-weight-semi-bold" },
                            " ",
                            ordinal.toOrdinal(this.props.interaction.paymentDay.day),
                            " "),
                        "of the month"),
                    React.createElement("div", { className: "my-3" },
                        React.createElement(react_router_dom_1.Link, { to: "/journey/show/product/FlowSubscription/process/mtaChangePaymentDay", id: "editPaymentDay", className: "font-weight-semi-bold" },
                            React.createElement("div", null, "Edit")))),
                this.renderQuestions())));
    };
    return ChangePaymentDayPriceOutputWidget;
}(React.Component));
exports.ChangePaymentDayPriceOutputWidget = ChangePaymentDayPriceOutputWidget;
//# sourceMappingURL=ChangePaymentDayPriceOutputWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/falconSelfService/ChangePaymentDayPriceOutputWidget.js
// module id = 3270
// module chunks = 0